/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Iframe_Remote_Blank_Frames_Invalid_Index_ErrorInputs */



/**
* | output |
* | --- |
* | "Invalid event group index. {index}" |
*
* @param {Iframe_Remote_Blank_Frames_Invalid_Index_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_blank_frames_invalid_index_error = /** @type {((inputs: Iframe_Remote_Blank_Frames_Invalid_Index_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Blank_Frames_Invalid_Index_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Index de groupe d'evenements invalide. ${i?.index}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Ungültiger Ereignisgruppenindex. ${i?.index}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Indice del gruppo di eventi non valido. ${i?.index}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Неверный индекс группы событий. ${i?.index}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Índice de grupo de eventos no válido. ${i?.index}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`无效的事件组索引。${i?.index}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`無効なイベント グループ インデックスです。${i?.index}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`अमान्य इवेंट समूह सूचकांक। ${i?.index}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Índice de grupo de eventos inválido. ${i?.index}`)
	return /** @type {LocalizedString} */ (`Invalid event group index. ${i?.index}`)
});